import { render, staticRenderFns } from "./langSelector.vue?vue&type=template&id=77240977&scoped=true"
import script from "./langSelector.vue?vue&type=script&lang=js"
export * from "./langSelector.vue?vue&type=script&lang=js"
import style0 from "./langSelector.vue?vue&type=style&index=0&id=77240977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77240977",
  null
  
)

export default component.exports